"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _checkbox = _interopRequireDefault(require("../form/checkbox"));
var _radio = require("../form/radio");
var _field = require("../form/field");
var _textfield = _interopRequireDefault(require("../form/textfield"));
var _indexModule = _interopRequireDefault(require("./index.module.scss"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const MIN_CHARACTERS_SEARCH_BY_KEYWORD = 2;
const Filter = _ref => {
  let {
    filterOptions,
    selectedOptions,
    onSelectionChange,
    selectSingle,
    searchByKeyword,
    name,
    id,
    size
  } = _ref;
  const toggle = (isChecked, option) => {
    const toggleOption = isChecked ? [...selectedOptions, option] : selectedOptions.filter(opt => opt !== option);
    const newSelected = selectSingle ? [option] : toggleOption;

    // radio button doesn't pass checked because there's no checked/unchecked
    const checked = selectSingle || isChecked;
    onSelectionChange(newSelected, {
      isChecked: checked,
      option
    });
  };

  // search by keyword
  // Note: This implementation assumes that the filter options do not change over time
  // Internal state used by search is set from the initial filter options from the props
  const [visibleOptionsAfterSearch, setVisibleOptionsAfterSearch] = (0, _react.useState)(filterOptions);
  const onSearchChange = e => {
    const {
      value
    } = e.target;
    if (value.length >= MIN_CHARACTERS_SEARCH_BY_KEYWORD) {
      const matches = [...filterOptions.filter(option => option.toLowerCase().includes(value.toLowerCase()))];
      setVisibleOptionsAfterSearch(matches);
    } else {
      setVisibleOptionsAfterSearch(filterOptions);
    }
  };
  const Element = selectSingle ? _radio.Radio : _checkbox.default;
  const elementId = option => {
    // remove non alphanumeric characters and replace with hyphen
    const optionNameForId = (0, _field.makeIdFromName)(option);
    return "".concat(id, "-").concat(selectSingle ? 'radio' : 'checkbox', "-").concat(optionNameForId);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.filterWrapper
  }, searchByKeyword && /*#__PURE__*/_react.default.createElement(_textfield.default, {
    classNames: {
      wrapper: _indexModule.default.search
    },
    placeholder: searchByKeyword.placeholder,
    name: "search-by-keyword-".concat(id, "-").concat(name),
    id: "search-by-keyword-".concat(id, "-").concat(name),
    size: size,
    type: "search",
    onChange: onSearchChange
  }), ((searchByKeyword ? visibleOptionsAfterSearch : filterOptions) || []).map(option => /*#__PURE__*/_react.default.createElement(Element, {
    key: option,
    label: option,
    name: "".concat(id, "-").concat(name),
    value: "".concat(id, "-").concat(option),
    checked: selectedOptions.includes(option),
    classNames: {
      wrapper: _indexModule.default.filter,
      label: _indexModule.default.filterLabel
    },
    dataTestId: elementId(option),
    id: elementId(option),
    size: size,
    onChange: isChecked => toggle(isChecked, option)
  })));
};
var _default = exports.default = Filter;